import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the layout class to add static property values
 * @param {Layout} Layout The layout to enhance
 * @param {Object} [arg1] Optional configuration values
 */
export const withLayoutConfig: PresetHOC<
    {
        config?: object;
    },
    object
> = (Layout, config = {}) => {
    Layout.config = config;

    return Layout;
};
